<template>
    <header style="background:#ffffff">
    <div class="container head-container">
      <div class="header-section d-flex align-items-center">
        <div class="header-logo d-flex align-items-center">
          <h2>
            <router-link to="/">
              <img src="../assets/images/bloom_logo.svg" style="width:100%; height:100%"/>
            </router-link>
          </h2>
        </div>
        <p><a href="javascript:;" class="d-flex align-items-center logout-btn"
            v-on:click="logout">
            ログアウト</a>
        </p>
        <!-- <div class="header-logo d-flex align-items-center mobile">
          <b-nav-item-dropdown right>
          <template #button-content>
            <i class="fa fa-user" style="color: #006C6B"/><em></em>
          </template>
          <b-dropdown-item>
            <router-link class="d-flex align-items-center" to="/"
              >
              ホーム
              </router-link>
            </b-dropdown-item>
          <b-dropdown-item>
            <router-link class="d-flex align-items-center" to="/user-profile"
              >
              情報編集
              </router-link>
          </b-dropdown-item>
          <b-dropdown-item v-if="contactCount !== 0">
            <router-link class="d-flex align-items-center" to="/contact-list"
              >
              個別連絡
              </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
             <router-link class="d-flex align-items-center" to="/settings"
              >
              設定
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <a href="javascript:;" class="d-flex align-items-center"
                v-on:click="logout" style="color:red; border-top:1px solid #E6E6E6" >
                ログアウト</a>
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </div> -->
      </div>
    </div>
    <div class="container header-container p-0">
      <div class="navbar header-list" >
        <router-link
          v-for="link in navbarLinks"
          :key="link.path"
          :to="link.path"
          class="navbar-item"
          :class="{ 'active-route': isHeaderRoute(link.route)}"
          :style="{width: navbarItemWidth}"
        >
          {{ link.label }}
          <span v-if="link.route === 'contactList' && unreadCount > 0" class="contact-count">
            {{ unreadCount }}
          </span>
        </router-link>
      </div>
    </div>
  </header>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'profileHeader',
  data(){
    return {
      currentRoute: '',
      headerRoutes: ['home','userProfile','changePassword','logout'],
    }
  },
  computed: {
    ...mapGetters({ contactCount: 'getContactCount', unreadCount: 'getUnreadContactCount' , profile: 'getProfile'}),
    navbarItemWidth() {
      return `${100/ this.navbarLinks.length}%`;
    },
    navbarLinks() {
      const hasAccess = Object.keys(this.profile).length > 0
      const links = [
        { path: '/', label: 'ホーム', show: true, route: 'home' },
        { path: '/job-listings', label: '求人検索', show: hasAccess, route: 'jobListings' },
        { path: '/contact-list', label: 'メッセージ', show: true, route: 'contactList'},
        { path: '/user-profile', label: '設定', show: true, route: 'userProfile' }
      ]
      return links.filter(link => link.show)
    }
  },
  methods: {
    ...mapActions(['loadContactCount']),
    logout() {
      this.$auth.logout();
    },
    isHeaderRoute(name){
      return this.currentRoute === name;
    }
  },
  mounted(){
    this.currentRoute = this.$route.name
  },
  async created(){
    await this.loadContactCount();
  }
};
</script>
<style>
  a {
    text-decoration: none !important;
  }
  .logout-btn{
    color: #000000 !important;
    font-weight: 700;
    font-size: 14px !important;
  }
  .navbar-item {
    position: relative;
  }
  .contact-count {
    position: absolute;
    top: 18%;
    margin-left: 5px;
    background-color: #006C6B;
    color: white;
    border-radius: 50%;
    padding: 0px;
    font-size: 12px;
    font-weight: bold;
    height: 20px;
    width: 20px;
    line-height: 20px;
    text-align: center;
  }
  .header-list {
    text-align: center;
    text-decoration: none !important;
  }
  .header-list a {
    color: #000000;
    font-weight: bold;
    font-size: 20px;
  }
  .header-list a:hover {
    text-decoration: none;
    opacity: 0.5;
  }
  .navbar {
    display: flex;
    justify-content: flex-start;
    padding: 0px !important;
  }
  /* .heaad{
    max-width:1700px;
  } */
  .active-route{
    color: #006C6B !important;
    border-bottom: 3px solid #006C6B !important;
  }
  a.nav-link{
    width: 84px;
  }
  .header-logo.mobile {
    display: none !important;
  }
  @media (max-width: 768px) {
    .header-list a {
      font-size: 16px;
    }
    .container.head-container {
      padding: 0 8px;
    }
    .header-logo {
      width: 60%;
    }
    .contact-count {
      top: -25%;
      margin-left: 2px;
      font-size: 10px;
      font-weight: bold;
      height: 18px;
      width: 18px;
    }
  }
  @media (max-width: 960px) {
  .container.header-container {
    max-width: 1700px;
    padding: 0px;
    margin: 0px;
  }
  .header-logo.mobile {
    display: inline-block !important;
    list-style-type: none;
    margin-top: 10px;
  }
  a.nav-link{
    width: 55px;
  }
  .dropdown-menu-right::before{
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    background: white;
    right:20px;
    top:-10px;
    transform: rotate(45deg);
    border-top: 1px solid #C4C4C4;
    border-left: 1px solid #C4C4C4;
  }
  .header-logo.dropdown:toggle::after{
    color: #006C6B;
  }
  .header-logo a{
    color: black;
  }
  /* .header-logo a{
    color: #006C6B
  } */
}
</style>

